var map = {
	"./ax1m.png": 3351,
	"./barrel.png": 2310,
	"./biopsy.png": 5189,
	"./blood.png": 6717,
	"./check.png": 8171,
	"./cow.png": 4214,
	"./cross.png": 741,
	"./farmer.png": 556,
	"./home.png": 4788,
	"./location.png": 1209,
	"./machine.png": 9921,
	"./microscope.png": 7749,
	"./more.png": 3325,
	"./omeat_green.png": 1282,
	"./recipe-book.png": 2940,
	"./settings.png": 3424,
	"./setup.png": 5801,
	"./ship.png": 995,
	"./tech.png": 1221,
	"./trash.png": 6892
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6303;